import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "../../../config/Api";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { jwtDecode } from "jwt-decode";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useLocation, useNavigate } from "react-router-dom";
import { HTTP_STATUS, HTTP_STATUS_MESSAGE } from "../../../constants/HttpStatus";
import { setLoggedInUser } from "service/AuthService";
import imageUrl from "../../../assets/images/omReactangular.png";
import MDAvatar from "components/MDAvatar";
import { useAuth } from "context/AuthContext";
// Validation Schema
const schema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().min(6, "Minimum 6 characters").required("Password is required"),
});

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const navigation = useNavigate();
  const location = useLocation();
  const onFinish = async (values) => {
    try {
      setLoading(true);
      let url = `om/auth/login`;
      let options = {
        method: "POST",
        url,
        data: values,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (
            response?.status == HTTP_STATUS.OK &&
            response?.data?.status == HTTP_STATUS_MESSAGE.OK
          ) {
            let decoded = jwtDecode(response?.data?.data);
            localStorage.setItem("token", response?.data?.data);
            const loggedInUser = {
              email: decoded?.sub,
              name: decoded?.employeeName,
              empId: decoded?.empId,
              roles: decoded?.roles && decoded?.roles[0],
              permissions: "",
              token: response?.data?.data,
              payee: "",
            };
            setAuth(loggedInUser);
            navigate("/");
            localStorage.setItem("auth", JSON.stringify(loggedInUser));
            // setAuth({ decodedToken?.sub, "", "", {}, [], response?.data?.data , "" });
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response) {
            setLoading(false);
            // setErrorDialog(true);
            console.error("err.res", err.response.data);
            showNotification("error", "Error", "Some error occured!");
          }
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      showNotification("error", "Error", "Some error occured!");
    }
    // setTimeout(() => {
    //   setLoading(false);
    //   if (values.username === "admin" && values.password === "admin123") {
    //     localStorage.setItem(
    //       "token",
    //       "uiywtyeuoinow ceuruj94380750498759084739ncioeuiryuo"
    //     );
    //     setAuth({
    //       name: "admin",
    //       username: "admin",
    //       id: "1212",
    //       permissions: "",
    //       role: ["Merchant"],
    //       token: "9874397482374kjdcnsjdkcnjskdcn",
    //       payee: "",
    //     });
    //     localStorage.setItem("persist", true);
    //     setPersist(true);
    //     navigate("/dashboard");
    //     showNotification(
    //       "success",
    //       "Login Successful",
    //       "You are now logged in!"
    //     );
    //   } else {
    //     message.error("Invalid username or password!");
    //   }
    // }, 1000);
  };

  const { setLoggedInUser } = useAuth();
  const onSubmit = async (data) => {
    setLoading(true); // show loader
    try {
      let url = `om/auth/login`;
      let options = {
        method: "POST",
        url,
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      await axios(options)
        .then((response) => {
          if (
            response?.status == HTTP_STATUS.OK &&
            response?.data?.status == HTTP_STATUS_MESSAGE.OK
          ) {
            localStorage.setItem("token", JSON.stringify(response?.data?.data));
            const from = location.state?.from?.pathname || "/dashboard";
            navigation(from, { replace: true });
            setLoading(false);
            setLoggedInUser(jwtDecode(response?.data?.data));
          } else {
            setError("api", {
              type: "manual",
              message: response?.data?.message || "Internal server error!",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          setError("api", {
            type: "manual",
            message: err.response?.data?.message || "Internal server error!",
          });
        });
    } catch (err) {
      console.log(err);
      setLoading(false);
      setError("api", {
        type: "manual",
        message: err.response?.data?.message || "Internal server error!",
      });
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          // variant="gradient"
          bgColor="#456ccfff"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            {/* <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid> */}
            <MDAvatar
              src={imageUrl}
              size="lg"
              variant="rounded"
              sx={{
                width: 180,
                height: 180,
                fontSize: 32,
                "& img": {
                  objectFit: "fill",
                },
              }}
            />
          </Grid>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            {/* Email */}
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                {...register("email")}
                // error={!!errors.email}
                // helperText={errors.email?.message}
              />
            </MDBox>

            {/* Password */}
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                {...register("password")}
                // error={!!errors.password}
                helperText={errors.password?.message}
              />
            </MDBox>

            {errors.api && (
              <MDTypography variant="caption" color="error">
                {errors.api.message}
              </MDTypography>
            )}

            {/* Submit */}
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth disabled={loading}>
                {loading ? (
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <CircularProgress size={22} color="white" />
                    Loading...
                  </MDBox>
                ) : (
                  "Sign In"
                )}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
